import type { AxiosResponse } from "axios"

import { axiosClient } from "$/http"

import { ECoachCalendarQueryUrl as EQueryUrl } from "./coach.calendar.api.config"
import {
    ICoachCalendarMsTeamsAccountDto as IMsTeamsAccountDto,
    ICoachCalendarRelinkAccountsQueryDto as IRelinkAccountsQueryDto,
    ICoachCalendarZoomAccountDto as IZoomAccountDto
} from "./coach.calendar.api.types"

async function zoomAccount(): Promise<IZoomAccountDto> {
    const { data }: AxiosResponse<IZoomAccountDto> = await axiosClient.get(EQueryUrl.ZoomAccount())

    return data
}

async function msTeamsAccount(): Promise<IMsTeamsAccountDto> {
    const { data }: AxiosResponse<IMsTeamsAccountDto> = await axiosClient.get(EQueryUrl.MsTeamsAccount())

    return data
}

async function relinkAccounts(): Promise<IRelinkAccountsQueryDto> {
    const { data }: AxiosResponse<IRelinkAccountsQueryDto> = await axiosClient.get(EQueryUrl.RelinkAccounts())

    return data
}

export default { zoomAccount, msTeamsAccount, relinkAccounts }
